import BaseModel from '../base';

export default class Tag extends BaseModel {
  constructor(tag, url) {
    super(tag, url);

    this.name = tag.name;
  }
}
